module.exports = "/images/Switzerland.png?6cc6585de1a452e15a39b7d1a0407755";